import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";


const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState: {
    breadCrumbs: [],
  },
  reducers: {
    setBreadcrumb: (state, action) => {
      state.breadCrumbs = action.payload;
    },
    
  },
});

export const { setBreadcrumb} = breadcrumbSlice.actions;
export const breadcrumbSelector = (state: RootState) => {
  return state.breadcrumb.breadCrumbs;
};


export default breadcrumbSlice.reducer;
